import { selector } from "recoil";
import { usingScenarioItemsState } from "./skippedScenarioItemsState";
import { completedComponentIdsState } from "./scenarioState";
import { formState, FormValues } from "./formState";

export const completedFormState = selector<FormValues | null>({
  key: 'completedForm',
  get({get}) {
    const items = get(usingScenarioItemsState);
    const completeComponentIds = new Set(get(completedComponentIdsState));
    if (!items.every(i => i.components.every(c => completeComponentIds.has(c.id)))) {
      return null;
    }

    const ret: FormValues = {};
    const form = get(formState);
    const componentIds = new Set(items.flatMap(i => i.components.map(c => c.id)));
    Object.keys(form).forEach((id) => {
      if (componentIds.has(id)) {
        ret[id] = form[id];
      }
    });
    return ret;
  }
})
